/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IAccountPaymentEditViewForm, IAccountPaymentSummaryViewForm, ICheckoutCustomerAccountPaymentViewProps } from './index';

export const SummaryForm: React.FC<IAccountPaymentSummaryViewForm> = ({
    formProps,
    label,
    addPaymentButton,
    appliedLine,
    bottomBorder,
    paymentAmountInput
}) => (
    <Node {...formProps}>
        <>
            {label}
            {paymentAmountInput}
            {addPaymentButton}
            {appliedLine}
            {bottomBorder}
        </>
    </Node>
);

export const EditForm: React.FC<IAccountPaymentEditViewForm> = ({
    formProps,
    inputLabel,
    inputAmount,
    addPaymentButton,
    customerName,
    customerSince,
    alert,
    appliedLine,
    bottomBorder
}) => (
    <Node {...formProps}>
        <>
            {customerName}
            {customerSince}
            {!appliedLine && inputLabel}
            {alert}
            {!appliedLine && inputAmount}
            {!appliedLine && addPaymentButton}
            {appliedLine}
            {bottomBorder}
        </>
    </Node>
);

const CheckoutCustomerAccountView: React.FC<ICheckoutCustomerAccountPaymentViewProps> = props => {
    const { selectPayment, removePayment, resources } = props;
    const [checked, setChecked] = React.useState(!!props.isOnAccountChecked);

    React.useEffect(() => {
        setChecked(!!props.isOnAccountChecked);
    }, [props.isOnAccountChecked]);

    return (
        <>
            {props.alert ? <div className='msc-alert msc-alert-danger'>{props.alert}</div> : null}
            <div className='ms-checkout-customer-account-payment__wrapper'>
                <input
                    type='checkbox'
                    id='payment'
                    name={resources.paymentOnAccount}
                    value={resources.paymentOnAccount}
                    checked={checked}
                    onChange={e => {
                        const shouldApply = e.target.checked;
                        setChecked(shouldApply);
                        // Notify parent component to update gating state
                        props.onAccountCheckedChange && props.onAccountCheckedChange(shouldApply);

                        if (shouldApply) {
                            void selectPayment();
                            props.moduleState.getModuleByTypeName('checkout').setHasError(false);
                        } else {
                            void removePayment();
                        }
                    }}
                ></input>
                <label htmlFor='payment'>{resources.paymentOnAccount}</label>
            </div>
        </>
    );
};

export default CheckoutCustomerAccountView;
